import { Backdrop, CircularProgress } from '@mui/material'
import { useState } from 'react';

export const useLoadingSpinner = () => {
    const [loadings, setLoadings] = useState<boolean[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const startLoading = () => {
        loadings.push(true);
        setLoadings(loadings);
        setIsLoading(true);
    }
    const stopLoading = () => {
        loadings.splice(0, 1);
        setLoadings(loadings);
        setIsLoading(loadings.length !== 0);
    }

    return { startLoading, stopLoading, isLoading }
}

export const LoadingSpinner = () => {
    return (
        <Backdrop sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, position: 'absolute' }} open={ true }>
            <CircularProgress color='inherit' />
        </Backdrop>
    );
}